import axios, { AxiosError, AxiosRequestConfig } from "axios";
import { localState } from "./LocalState";

const ApiCentralAjuda = axios.create({
    baseURL: process.env.REACT_APP_URL_CENTRAL_AJUDA_API,
    headers: {
        "Content-Type": "application/json",
    },
});

function onRequestSuccess(config: AxiosRequestConfig) {
    const token = localState.getLocalState("gu_token");
    const userId = localState.getLocalState("usuario_id");
    if (token && userId) {
        if (
            config.headers &&
            !["/getToken", "/validateToken"].includes(config.baseURL as string)
        ) {
            config.headers.Authorization = `Bearer#${token}`;
            config.headers.From = userId;
        }
    }
    return config;
}

function onRequestFailed(error: AxiosError) {
    return Promise.reject(error);
}

ApiCentralAjuda.interceptors.request.use(onRequestSuccess, onRequestFailed);

export default ApiCentralAjuda;
